export const HitCodes = {
  A: "Consumer requested security freeze on his/her credit file",
  G: "Consumer requested security freeze on his/her credit file",
  "L*": "Consumer requested Equifax lock on his/her credit file",
  "M*": "Consumer requested Equifax lock on his/her credit file",
  I: "Information from consumer inquiry has been identified as potentially fraudulent or misused, therefore the credit report is not available for delivery"
};

export const errorHitCodes = ["A", "G", "L*", "M*", "I"];
